export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        //
        // Bottom Slider
        //
        $('.subscription-landing-page-second-panel__bottom-slider .swiper').each(function (item, value) {
            // console.log('hello world abc 123');
            new window.Swiper(
                value,
                {
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: true,
                    slideToClickedSlide: false,
                    // keyboard control
                    keyboard: {
                        enabled: true,
                    },
                    observer: true,
                    observeParents: true,
                    breakpoints: {
                        570: {
                            spaceBetween: 16,
                            slidesPerView: 'auto',
                        },
                        750: {
                            spaceBetween: 16,
                            slidesPerView: 'auto',
                        },
                        1040: {
                            spaceBetween: 32,
                            slidesPerView: 'auto',
                        },
                        1280: {
                            spaceBetween: 32,
                            slidesPerView: 'auto',
                        },
                    },
                }
            );
        });
    },
};
